export enum ModeEnum {
  mailRead,
  mailCompose,
  mailSend,
  office,
  contentManager,
  contentManagerAdvancedSearch,
  contentManagerTeams
}
